import { withDependencies } from '@wix/thunderbolt-ioc'
import type { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { CustomCssAPISymbol, ICustomCssAPI } from 'feature-custom-css'

const viewerManagerCustomCssApiFactory = (customCssAPI: ICustomCssAPI): IViewerManagerImplementor<'customCSS'> => {
	return {
		customCSS: {
			refresh: customCssAPI.refreshCustomStyles,
		},
	}
}
export const ViewerManagerCustomCssApi = withDependencies([CustomCssAPISymbol], viewerManagerCustomCssApiFactory)
